import React, {Component} from "react";
// La instancia directa y no `src/i18n.js`, como `DashboardCell`: importar ese módulo rompe las suites
// que mockean `react-i18next` sin el stub de `initReactI18next`.
import i18next from "i18next";
import {ADGROUP_STATUS_ACTIVE} from "../../../marketing";

export class AdgroupNameCell extends Component {

    renderStatus() {
        if(this.props.status !== ADGROUP_STATUS_ACTIVE) {
            const label = i18next.isInitialized ? i18next.t('dashboard.adgroup_not_active') : '[No activo]';
            return <span className="ml-2 mr-2  status_not_active">{label}</span>
        }
        return ""
    }

    renderName() {
        if(this.props.insideCampaignRow)
            return <span>➡️ {this.props.adgroupName}{this.renderStatus()}</span>;
        return <span>{this.props.campaignName} ➡️ {this.props.adgroupName}{this.renderStatus()}</span>;
    }

    render() {
        return (
            <td>
                <div className="bu-cell ad_account_row">
                    <div className="bu-name-with-tooltip">
                        <div className="adgroup-name" title={this.props.adgroupName}>
                            {this.renderName()}
                        </div>
                    </div>
                    <div className="some-icons">
                        &nbsp;
                    </div>
                </div>
            </td>
        );
    }
}
